// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding-redirect-modal .action-btn-group {
  display: flex;
  gap: var(--spacing-small);
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Onboarding/OnboardingRedirectModal/OnboardingRedirectModal.less"],"names":[],"mappings":"AAAA;EAEI,aAAA;EACA,yBAAA;AAAJ","sourcesContent":[".onboarding-redirect-modal {\n  .action-btn-group {\n    display: flex;\n    gap: var(--spacing-small);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
